import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import zhibodaping from './views/zhibodaping.vue'
import Home from './views/Home.vue'

import shouye from './views/pages/shouye/shouye.vue'
import zhibo from './views/pages/zhibo/zhibo.vue'
import wode from './views/pages/wode/wode.vue'
import zhibojian from './views/pages/zhibojian/zhibojian.vue'
import bofangshipin from './views/pages/bofangshipin/bofangshipin.vue'


let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
	{
	    path: '/',
	    component: Home,
	    name: '首页',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670575807654.undefined',
	    selectedIconCls:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/176705761266569.undefined',
	    children: [
	        { path: '/shouye', component: shouye, name: '首页',meta:{CnName:'首页',EnName:'Home',TwName:'首頁'} },
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '直播',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576515180.undefined',
	    selectedIconCls:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/1767057668024138.undefined',
	    children: [
	        { path: '/zhibo', component: zhibo, name: '直播',meta:{CnName:'直播',EnName:'Live',TwName:'直播'} },
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '我的',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576903559.undefined',
	    selectedIconCls:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/1767057707558124.undefined',
	    children: [
	        { path: '/wode', component: wode, name: '我的' ,meta:{CnName:'我的',EnName:'My',TwName:'我的'}},
	    ]
	},
    {
        path: '/',
        component: Home,
        name: '',
        hidden: true,
        children: [
           
        ]
    },
    {
        path: '/zhibojian',
        name: 'zhibojian', // 路由名称
        component: zhibojian, // 新页面组件
    	hidden: true
    },
	{
	    path: '/bofangshipin',
	    name: 'bofangshipin', // 路由名称
	    component: bofangshipin, // 新页面组件
		hidden: true
	},
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js